import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  CodeOutlined,
  SettingOutlined,
  ProfileOutlined,
  SyncOutlined,
  TeamOutlined,
  FormOutlined,
  FileTextOutlined,
  ExperimentOutlined,
} from "@ant-design/icons";

import { Menu } from "antd";

import styles from "./Nav.module.scss";
import {
  getStoredPageSettings,
  updateStoredPageSettings,
} from "../../utils/settings";
import { useUser } from "../../common/permissions";

const ALL_SECTION_KEYS = ["s1", "s2", "s3"];
const NAV_STORAGE_KEY = "nav.settings";

const Settings = (props) => {
  const { collapsed, navSelectedKeys } = props;
  const currentUser = useUser();
  const currentUserId = currentUser?.id;
  const canManageSettings = Boolean(currentUser && currentUser.super_admin);

  const [openSections, setOpenSections] = useState(() => {
    const settings = getStoredPageSettings(NAV_STORAGE_KEY);
    return settings.openSections || ALL_SECTION_KEYS;
  });

  const handleOpenChange = (newSections) => {
    if (collapsed) return;
    setOpenSections(newSections);
    updateStoredPageSettings(NAV_STORAGE_KEY, { openSections: newSections });
  };

  const getMenuItems = () => {
    const items = [];

    // Users Group
    const usersGroup = {
      key: "s1",
      label: "Users",
      children: [
        {
          key: "profile",
          label: (
            <NavLink to={`/settings/users/${currentUserId}`}>
              <ProfileOutlined />
              <span>Profile</span>
            </NavLink>
          ),
          className: styles.siderMenuItem,
        },
      ],
    };

    if (canManageSettings) {
      usersGroup.children.push({
        key: "users",
        label: (
          <NavLink to="/settings/users">
            <TeamOutlined />
            <span>Users</span>
          </NavLink>
        ),
        className: styles.siderMenuItem,
      });
    }

    items.push(usersGroup);

    if (canManageSettings) {
      // Customization Group
      items.push({
        key: "s2",
        label: "Customization",
        children: [
          {
            key: "labels",
            label: (
              <NavLink to="/settings/labels">
                <SettingOutlined />
                <span>Labels</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "acquisitions_settings",
            label: (
              <NavLink to="/settings/acquisitions">
                <SettingOutlined />
                <span>Acquisitions</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "mail_templates",
            label: (
              <NavLink to="/settings/mail-templates?limit=50&page=1">
                <FormOutlined />
                <span>Mail templates</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
        ],
      });

      // Processes Group
      items.push({
        key: "s3",
        label: "Processes",
        children: [
          {
            key: "pipedrive_syncs",
            label: (
              <NavLink to="/settings/pipedrive-syncs?limit=50&page=1">
                <SyncOutlined />
                <span>Pipedrive syncs</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "enverus_syncs",
            label: (
              <NavLink to="/settings/enverus-syncs?limit=50&page=1">
                <SyncOutlined />
                <span>Enverus syncs</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "rrc_syncs",
            label: (
              <NavLink to="/settings/rrc-syncs?limit=50&page=1">
                <SyncOutlined />
                <span>RRC syncs</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "sonris_syncs",
            label: (
              <NavLink to="/settings/sonris-syncs?limit=50&page=1">
                <SyncOutlined />
                <span>SONRIS syncs</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "owner_syncs",
            label: (
              <NavLink to="/settings/owner-syncs?limit=50&page=1">
                <SyncOutlined />
                <span>Owner syncs</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "file_parses",
            label: (
              <NavLink to="/settings/file-parses?limit=50&page=1">
                <FileTextOutlined />
                <span>File parses</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "forecast_backtests",
            label: (
              <NavLink to="/settings/forecast-backtests?limit=50&page=1">
                <ExperimentOutlined />
                <span>Forecast backtests</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "parse_backtests",
            label: (
              <NavLink to="/settings/parse-backtests?limit=50&page=1">
                <ExperimentOutlined />
                <span>Parse backtests</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
          {
            key: "jobs",
            label: (
              <NavLink to="/settings/jobs">
                <CodeOutlined />
                <span>Jobs</span>
              </NavLink>
            ),
            className: styles.siderMenuItem,
          },
        ],
      });
    }

    return items;
  };

  return (
    <Menu
      theme="light"
      mode="inline"
      className={collapsed ? null : styles.siderMenu}
      selectedKeys={navSelectedKeys}
      openKeys={collapsed ? [] : openSections}
      onOpenChange={handleOpenChange}
      items={getMenuItems()}
    />
  );
};

export default Settings;
